var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/landing/logo_black.png",
            searchImgSrc: "../../../../static/img/landing/search_black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-MainContainer" }, [
      _c(
        "main",
        {
          staticClass: "st-MainContents",
          staticStyle: { "padding-top": "120px" }
        },
        [
          _c("header", { staticClass: "company-PageTitle" }, [
            _c("div", { staticClass: "company-PageTitle_Inner" }, [
              _c(
                "h1",
                {
                  staticClass: "company-PageTitle_Inner_Title",
                  attrs: { "data-appear": "" }
                },
                [
                  _c("span", { staticClass: "company-PageTitle_Logo" }, [
                    _c("b", [_vm._v("COMPANY")])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "company-PageTitle_Title" }, [
                    _c("b", [_vm._v("企業情報")])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sw-parallax" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_outer js-parallax_outer" },
                  [
                    _c("div", { staticClass: "sw-parallax_inner" }, [
                      _c(
                        "div",
                        { staticClass: "sw-parallax_block js-parallax_block" },
                        [
                          _c("div", { staticClass: "sw-parallax_target" }, [
                            _c(
                              "div",
                              { staticClass: "company-PageTitle_Slide" },
                              [
                                _c("div", {
                                  staticClass:
                                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                                  staticStyle: {
                                    background:
                                      "url(../../../../static/img/landing/childpageimg1.png) 20%/cover no-repeat"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                                  staticStyle: {
                                    background:
                                      "url(../../../../static/img/landing/childpageimg1.png) 20%/cover no-repeat"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "company-Profile" }, [
            _c("div", { staticClass: "company-Profile_Inner" }, [
              _c(
                "h3",
                {
                  staticClass: "sw-Section_HeaderS",
                  attrs: { "data-appear": "" }
                },
                [
                  _c("span", { staticClass: "sw-Section_HeaderS-en" }, [
                    _c("b", [_vm._v("COMPANY PROFILE")])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sw-Section_HeaderS-ja" }, [
                    _c("b", [_vm._v("会社概要")])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "company-Profile_List",
                  attrs: { "data-appear": "" }
                },
                [
                  _c("dl", [
                    _c("dt", [_vm._v("会社名")]),
                    _vm._v(" "),
                    _c("dd", [
                      _c("div", { staticClass: "company-Profile_List-block" }, [
                        _c("a", { attrs: { href: "/" } }, [
                          _c(
                            "p",
                            { staticClass: "company-Profile_List-text" },
                            [_vm._v("ナイスセラ株式会社 ")]
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("代表者")]),
                    _vm._v(" "),
                    _c("dd", [
                      _c("div", { staticClass: "company-Profile_List-block" }, [
                        _c("a", { attrs: { href: "/" } }, [
                          _c(
                            "p",
                            { staticClass: "company-Profile_List-text" },
                            [_vm._v("小山 雄")]
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v("設立")]),
                    _vm._v(" "),
                    _c("dd", [
                      _c("div", { staticClass: "company-Profile_List-block" }, [
                        _c("p", { staticClass: "company-Profile_List-text" }, [
                          _vm._v("平成29年12月 "),
                          _c("br", { staticClass: "sp" })
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", { staticClass: "location" }, [
                    _c("dt", [_vm._v("本社/営業所所在地")]),
                    _vm._v(" "),
                    _c("dd", [
                      _c("div", { staticClass: "company-Profile_List-block" }, [
                        _c(
                          "div",
                          { staticClass: "company-Profile_List-label" },
                          [_vm._v("ナイスセラ株式会社(日本本部)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "company-Profile_List-text" },
                          [
                            _vm._v("〒436-0016 掛川市板沢1945番地の11"),
                            _c("br"),
                            _vm._v("\n                      TEL:0537-54-3336 "),
                            _c("br"),
                            _vm._v("FAX:0537-54-3337\n                    ")
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "a",
                          { attrs: { href: "http://www.simso-precision.com" } },
                          [
                            _c(
                              "div",
                              { staticClass: "company-Profile_List-label" },
                              [_vm._v("上海心尚精密机械有限公司（営業所）")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "company-Profile_List-text" },
                          [
                            _vm._v(
                              "中国上海市宝山区城银路525弄绿地领创国际20楼2011室"
                            ),
                            _c("br"),
                            _vm._v("\n                      TEL:021-6083102 "),
                            _c("br"),
                            _vm._v("FAX:021-6083103\n                    ")
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", { staticClass: "location" }, [
                    _c("dt", [_vm._v("工場所在地")]),
                    _vm._v(" "),
                    _c("dd", [
                      _c("div", { staticClass: "company-Profile_List-block" }, [
                        _c(
                          "a",
                          { attrs: { href: "http://www.simso-precision.com" } },
                          [
                            _c(
                              "div",
                              { staticClass: "company-Profile_List-label" },
                              [_vm._v("嘉兴市耐思威精密机械有限公司（工場）")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "company-Profile_List-text" },
                          [
                            _vm._v("浙江省嘉兴市秀洲区高照街道康和路500号B12"),
                            _c("br"),
                            _vm._v(
                              "\n                      TEL:(86)573-8205-8763 "
                            ),
                            _c("br"),
                            _vm._v(
                              "FAX:(86)573-8205-9363\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("a", { attrs: { href: "http://www.dglangdi.cn" } }, [
                          _c(
                            "div",
                            { staticClass: "company-Profile_List-label" },
                            [_vm._v("中国东莞市长安朗迪精密五金制品(工場)")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "company-Profile_List-text" },
                          [
                            _vm._v("东莞市长安镇厦边上朗路6号"),
                            _c("br"),
                            _vm._v("\n                    TEL:18929295480 "),
                            _c("br"),
                            _vm._v(
                              "Email:ceo@dglangdi.cn\n                    "
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", { staticClass: "business" }, [
                    _c("dt", [_vm._v("グループ会社")]),
                    _vm._v(" "),
                    _c("dd", [
                      _c("div", { staticClass: "company-Profile_List-block" }, [
                        _c("a", { attrs: { href: "http://rbb.co.jp/" } }, [
                          _c(
                            "div",
                            { staticClass: "company-Profile_List-label mt-5" },
                            [_vm._v("RBB株式会社")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "company-Profile_List-text" },
                          [
                            _vm._v("〒409-3822 山梨県中央市下三條605-2"),
                            _c("br"),
                            _vm._v("\n                    TEL:055-215-8289 "),
                            _c("br"),
                            _vm._v("FAX:055-207-3790\n                    ")
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dl", { staticClass: "business" }, [
                    _c("dt", [_vm._v("事業内容")]),
                    _vm._v(" "),
                    _c("dd", [
                      _c("div", { staticClass: "company-Profile_List-block" }, [
                        _c("p", { staticClass: "company-Profile_List-text" }, [
                          _c("span", [
                            _vm._v(
                              "精密部品加工/委託材料加工/ステンレス製品/アルミ合金製品/高性能のプラスチック製品/純チタン製品/チタン合金製品/高硬度材先端セラミック製品/高純度単結晶シリコン製品/炭化ケイ素製品"
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "st-Breadcrumbs" }, [
        _c(
          "ul",
          {
            staticClass: "st-BreadcrumbsList",
            attrs: {
              itemscope: "itemscope",
              itemtype: "https://schema.org/BreadcrumbList"
            }
          },
          [
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: "https://schema.org/ListItem"
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "st-BreadcrumbsList_Item-link",
                    attrs: { href: "/" }
                  },
                  [
                    _c(
                      "p",
                      { attrs: { itemprop: "item", "aria-current": "page" } },
                      [
                        _c("span", { attrs: { itemprop: "name" } }, [
                          _vm._v("ホーム")
                        ])
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: "https://schema.org/ListItem"
                }
              },
              [
                _c(
                  "p",
                  { attrs: { itemprop: "item", "aria-current": "page" } },
                  [
                    _c("span", { attrs: { itemprop: "name" } }, [
                      _vm._v("企業情報")
                    ])
                  ]
                )
              ]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dd80e80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd80e80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/company/company.vue
// module id = null
// module chunks = 